"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLedgerTransport = exports.isBrowserSupported = void 0;
const hw_transport_webhid_1 = __importDefault(require("@ledgerhq/hw-transport-webhid"));
function isBrowserSupported() {
    if (!navigator)
        throw new Error("this function is only supported for use on browsers");
    const windowObject = window;
    const ua = navigator.userAgent.toLowerCase();
    const isChrome = /chrome|crios/.test(ua) && !/edge|opr\//.test(ua);
    const isBrave = isChrome && !windowObject.google;
    if (!isChrome && !isBrave) {
        throw new Error("Your browser doesn't support Ledger devices.");
    }
    return true;
}
exports.isBrowserSupported = isBrowserSupported;
function getDevicePaths(ledgerLibrary) {
    return __awaiter(this, void 0, void 0, function* () {
        const supported = yield ledgerLibrary.isSupported();
        if (!supported) {
            throw new Error("Your computer does not support the ledger!");
        }
        return yield ledgerLibrary.list();
    });
}
function getWebHIDTransport() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield hw_transport_webhid_1.default.create();
        }
        catch (error) {
            if (error.message !== "The device is already open.")
                throw error;
            const devices = yield getDevicePaths(hw_transport_webhid_1.default);
            const transport = new hw_transport_webhid_1.default(devices[0]);
            return transport;
        }
    });
}
function getLedgerTransport() {
    return __awaiter(this, void 0, void 0, function* () {
        return getWebHIDTransport();
    });
}
exports.getLedgerTransport = getLedgerTransport;
